<yat-payment-method-selection-common id="a14ade61-0bf8-4faf-8d17-2de5fff2ded4"
  [walletButtonsTemplate]="walletButtonTmpl"
  [paymentMethods]="(paymentMethods$ | async) ?? []"
  [updateSubscriptionWithContractId]="managedContractId$ | async"
  [selectedPaymentMethod]="connectedPaymentMethod$ | async"
  [allowToDeleteUsed]="(canConnectedPaymentMethodBeReplaced$ | async) ?? false"
  [showWalletButtons]="true"
  (saveSelection)="saveConnectedPaymentMethod($event)"
  (prepareDeleteMethod)="prepareDeletePaymentMethod($event)"
  (deleteMethod)="deletePaymentMethod($event)">
</yat-payment-method-selection-common>
<ng-template #walletButtonTmpl let-activeWalletData>
  <ng-container *ngIf="toWalletPaymentMethodType(activeWalletData); let activeWallet"
    ><yat-subscription-wallet-button id="5eec9f4a-b645-41f3-a3f6-bbe351c0e7f3" [activeWallet]="activeWallet"></yat-subscription-wallet-button></ng-container
></ng-template>
